import { LensBlur, PanTool, Timelapse } from '@mui/icons-material';
import Typewriter from 'typewriter-effect';
import me from '../assets/avatar.jpg';
import { Fade } from 'react-reveal';
import { Link } from 'react-router-dom';
import pdf from '../assets/resume_updated.pdf'

const Intro = () => {
    return (
        <div id='home'>
            <br />
            <center>
                <div className='intro'>

                    <div className='typeWrite reflect overlay mb'>
                        <div>
                            <Typewriter
                                options={{
                                    autoStart: true,
                                    loop: true,

                                }}

                                onInit={(typewriter) => {

                                    typewriter
                                        .pauseFor(500)
                                        .typeString("Welcome to my site!")
                                        .pauseFor(2000)
                                        .deleteAll(1)
                                        .typeString("I design websites and mobile apps!")
                                        .pauseFor(500)
                                        .start();
                                }}
                            />
                        </div>
                    </div>
                    <div className='abt-me-sm'>
                        <h5 className='my-name mt-3'> <LensBlur /> MY NAME IS TOBI OLALEYE <LensBlur /></h5>
                        <p className='about'>
                            I'm a <span className='fw-bold'>full stack web/mobile app developer</span> capable of end-to-end dynamic application software development.</p>
                    </div>

                </div>


                <div className="seperate_intro">
                    <div className="txt-about-me">
                        <h5 className='my-name mt-3'> <LensBlur /> MY NAME IS TOBI OLALEYE <LensBlur /></h5>
                        <p className='about'>
                            I'm a <span className='fw-bold'>full stack web/mobile app developer</span> capable of end-to-end dynamic application software development.</p>
                        <Fade bottom duration={3000}>
                            <section className="intro-btn-lg">
                                <Link to='/resume' className="">
                                    <button className="btn resume ">
                                        Resume
                                    </button>
                                </Link>
                                &nbsp; &nbsp;
                                <a href="https://wa.me/+2348148749736" target='_blank'>
                                    <button className="btn hire ">Hire me</button>
                                </a>
                            </section>
                        </Fade>
                    </div>
                    {/* digital transformation */}

                    <Fade duration={1000}>
                        <div className="my-container">
                            <div className="invisible-txt">
                                {/* <small style={{ fontSize: '14px', marginBottom: '7px' }}> I'm a programmer. I'd love to change the world one day, but sadly they won't give me the source code <b> :(</b></small> */}
                                <small style={{ fontSize: '14px', marginBottom: '7px' }}> Coding started as an outlet for me, but now it's simply a way of life <b> :)</b></small>
                                <div className='text-end fw-bold'>~CYBER WOLF</div>
                            </div>
                        </div>
                    </Fade>


                    <section className="intro-btn">
                        {/* <Link to='/resume' className=""> */}
                        <a href={pdf} download>
                            <button className="btn resume">
                                Resume
                            </button>
                        </a>
                        {/* </Link> */}
                        &nbsp; &nbsp;
                        <a href="https://wa.me/+2348148749736" target='_blank'>
                            <button className="btn hire ">Hire me</button>
                        </a>
                    </section>
                </div>

            </center>



        </div>
    );
};

export default Intro;